<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-12 12:24:01
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-19 10:41:45
-->
<template>
  <div>
    <div class="head">
      <div style="display: flex; align-items: center">
        <div class="back" @click="toBack"><a-icon type="arrow-left" /></div>
        <div style="font-size: 18px; color: #303133; font-weight: bold">
          &emsp;{{ itemId ? "编辑问答" : "新增问答" }}
        </div>
      </div>
    </div>
    <div>
      <el-form
        :model="collectForm"
        ref="collectForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
        :style="{height:height}"
      >
        <el-form-item label="问题分类" prop="isQuestionClassificationId">
          <el-select
            style="width: 100%"
            v-model="collectForm.isQuestionClassificationId"
            placeholder="请选择问题分类"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.classificationName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题描述" prop="questionDescription">
          <el-input
            v-model="collectForm.questionDescription"
            placeholder="请输入问题描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input
            placeholder="填写此问题可能被命中的关键词，可添加多个"
            v-model="keyword"
          >
            <template slot="append"
              ><div class="add-word" @click="addkeys">
                添加关键词
              </div></template
            >
          </el-input>
          <div>
            <div class="key-style" v-for="(item, index) in keysword">
              <div>{{ item }}</div>
              <div @click="deleteKeys(index)" style="cursor: pointer">
                <span class="icon-semi-close"></span>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="问题答案">
          <div class="editor-style">
            <Toolbar
              :editor="editor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />
            <Editor
              style="height: 200px"
              v-model="collectForm.questionAnswer"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreated"
            />
          </div>
        </el-form-item>
        <el-form-item label="允许评价" prop="whetherEvaluate">
          <div class="status">
            <el-radio v-model="collectForm.whetherEvaluate" :label="1"
              >启用</el-radio
            >
            <el-radio v-model="collectForm.whetherEvaluate" :label="0"
              >停用</el-radio
            >
          </div>
        </el-form-item>
        <el-form-item label="状态" prop="validStatus">
          <div class="status">
            <el-radio v-model="collectForm.validStatus" :label="1"
              >永久有效</el-radio
            >
            <el-radio v-model="collectForm.validStatus" :label="0"
              >自定义有效期</el-radio
            >
          </div>
        </el-form-item>
        <el-form-item label="有效期">
          <div class="block">
            <el-date-picker
             :disabled="collectForm.validStatus == 1"
              v-model="collectForm.collectTime"
              type="datetimerange"
              style="width: 100%"
              range-separator="至"
              start-placeholder="开始日期 时间"
              end-placeholder="结束日期 时间"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div class="form-bottom">
            <el-button
              :loading="loadingSubmint"
              @click="saveCollect"
              size="medium"
              type="primary"
              >保存</el-button
            >
          </div>
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { saveQuestionAnswer,editDel,list,updateQuestionAnswer } from "./custom_variables";
import { message } from 'ant-design-vue';
export default {
  data() {
    return {
      isEdit: false,
      collectForm: {},
      editor: null,
      height:0,
      loadingSubmint: false,
      mode: "default", // or 'simple'
      toolbarConfig: {
        excludeKeys: [
          "todo",
          "emotion",
          "fullScreen",
          "undo",
          "redo",
          "divider",
          "codeBlock",
          "insertTable",
          "group-video",
          'group-image',
          'group-indent',
          'group-justify',
          'numberedList',
          'bulletedList',
          'lineHeight',
          'fontFamily',
          'fontSize',
          'headerSelect',
          'blockquote',
          'code',
          'sup',
          'sub',
          'bgColor'
        ],
      },
      htmlContent: "",
      editorConfig: {
        MENU_CONF: {
          fontFamily: {
            fontFamilyList: [
              "仿宋_GB2312",
              "黑体",
              "仿宋",
              "楷体",
              "标楷体",
              "华文仿宋",
              "华文楷体",
              "宋体",
              "微软雅黑",
              "Arial",
              "Tahoma",
              "Verdana",
              "Times New Roman",
              "Courier New",
            ],
          },
          uploadImage: {
            server: "http://192.168.1.10:8080/site-service/m/cover/uploadImage",
            fieldName: "file",
            meta: {
              type: "img",
            },
            headers: {
              token: sessionStorage.getItem("token"),
            },
            customInsert: this.customInsert,
          },
        },
      },
      options: [],
      keyword: "",
      keysword: [],
      itemId:0,
      rules:{
        isQuestionClassificationId:[
           { required: true, message: "请选择问题", trigger: "blur" },
        ],
        validStatus:[
           { required: true, message: "请选择状态", trigger: "blur" },
        ],
        questionDescription:[
           { required: true, message: "请输入问题描述", trigger: "blur" },
        ],
        whetherEvaluate:[
          { required: true, message: "请选择允许评价", trigger: "blur" },
        ]
      }
    };
  },
  components: { Editor, Toolbar },
  mounted(){
    this.itemId = this.$route.query.id;
    if(this.itemId){
      this.getDels();
    }
    this.getGroup();
    this.height = `${document.documentElement.clientHeight - 320}px`;
    window.onresize = () => {
                            return (() => {
                                this.height = `${document.documentElement.clientHeight - 320}px`;
                            })();
                        };
  },
  methods: {
    getGroup(){
      list({
        siteId:sessionStorage.getItem('siteId')
      }).then((res)=>{
          if(res.code == 0){
            this.options = res.data;
          }
      })
    },
     farmatDate(date,cut) {
        var date = new Date(date)
        var YY = date.getFullYear() + cut ;
        var MM = (date.getMonth() + 1 < 10? "0" + (date.getMonth() + 1): date.getMonth() + 1) + cut;
        var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var hh =(date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        var mm =(date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +":";
        var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return YY + MM + DD + " " + hh + mm + ss;
    },
    getDels(){
        editDel({
          id:this.itemId,
        }).then((res)=>{
            if(res.code == 0){
                this.collectForm = res.data;
                this.collectForm.collectTime = [new Date(this.collectForm.validStartTime),new Date(this.collectForm.validEndTime)]
                if(res.data.keyWords){
                  this.keysword = res.data.keyWords.split(',')
                }
            }
        })
    },
    toBack() {
      this.$router.push({
            path: "/index/interaction/knowledge_base",
          });
    },
    saveCollect() {
      this.$refs.collectForm.validate((valid) => {
         if(valid){
            let validStartTime = '';
      this.loadingSubmint = true;
      let validEndTime = '';
      if(this.collectForm.collectTime){
         validStartTime =this.farmatDate(new Date( this.collectForm.collectTime[0].toString()).getTime(),'-')
         validEndTime = this.farmatDate(new Date( this.collectForm.collectTime[1].toString()).getTime(),'-')
      }
      if(this.itemId){
        updateQuestionAnswer({
        siteId: sessionStorage.getItem("siteId"),
         ...this.collectForm,
        keyWords: this.keysword.join(","),
        validStartTime,
        validEndTime,
      }).then((res) => {
         if(res.code == 0){
             this.$router.push({
              path: "/index/interaction/knowledge_base",
            });
         }
         this.loadingSubmint = false;
      });
      }else{
        saveQuestionAnswer({
        siteId: sessionStorage.getItem("siteId"),
        keyWords: this.keysword.join(","),
        ...this.collectForm,
        validStartTime,
        validEndTime,
      }).then((res) => {
         if(res.code == 0){
             this.$router.push({
              path: "/index/interaction/knowledge_base",
            });
         }
          this.loadingSubmint = false;
      });
      }
         }
      })
      
    },
    addkeys() {
      if(!this.keyword){
          message.error('请输入关键词');
          return;
      }
      this.keysword.push(this.keyword);
      this.keyword = '';
    },
    deleteKeys(index) {
      this.keysword.splice(index, 1);
    },
    onCreated(editor) {
      let a = (this.editor = Object.seal(editor)); // 一定要用 Object.seal() ，否则会报错
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.head {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #dcdfe6;
  padding: 18px 24px;
}
.demo-ruleForm {
  width: 520px;
  margin-top: 50px;
  padding-left: 24px;
  overflow:hidden;
  overflow-y: auto;
  padding-right: 20px;
  .key-style {
    height: 40px;
    line-height: 20px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid #888888;
    line-height: 40px;
    padding-left: 9px;
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 12px;
  }
}
.editor-style {
  border: solid 2px #dcdfe6;
}
.status {
  border: solid 1px #dcdfe6;
  border-radius: 4px;
  padding-left: 10px;
}
.icon-semi-save:before {
  color: #fff;
}
/deep/ .w-e-toolbar{
  border-bottom: solid 2px  #dcdfe6;
}
.back{
  cursor: pointer;
}
.el-button--primary {
  background: #176de6;
}
/deep/ .w-e-modal button{
  line-height: 20px;
}
/deep/ .el-input-group__append{
  padding: 0px;
}
.add-word{
  cursor: pointer;
  padding: 0 20px;
}
.form-bottom{
    margin-left: 124px;
    margin-top: 24px;
    margin-bottom: 24px;
}
</style>